import {
  SET_CONTEXT_MENU_VISIBILITY,
  SET_MULTIPLE_SELECTION,
} from "./types";

export function setContextMenuVisibility(data: object) {
  return {
    type: SET_CONTEXT_MENU_VISIBILITY,
    data
  }
}

export function setMultipleSelectionv2(data: boolean) {
  return {
    type: SET_MULTIPLE_SELECTION,
    data
  }
}
